// This list is based on the most common errors we see from Bandwidth and Twilio
// Documentation for error messages that Bandwidth and Twilio return can be found here:
// https://dev.bandwidth.com/docs/messaging/errors/
// https://www.twilio.com/docs/api/errors#30000-39999
export const hostingPartnerErrorMessage: Record<string, Record<string, string>> = {
  '4720': {
    title: 'Client number cannot be reached',
    description:
      "The client's phone number does not support text messaging. (4720) Please confirm with client that this number can receive texts, or resend text to a different phone number",
  },
  '9902': {
    title: 'SMS delivery unconfirmed by client’s carrier',
    description:
      "The client's carrier did not indicate delivery status of this message. (9902) Please double check with client of SMS delivery or resend as a Chat Message",
  },
  '4405': {
    title: 'Error Sending SMS',
    description: 'Text not delivered. (4405) Please contact Otto Support',
  },
  '4750': {
    title: "Message rejected by client's carrier",
    description:
      "The client's carrier rejected text from delivering without providing a specific reason. (4750) Please resend as a Chat Message",
  },
  '4700': {
    title: 'Client number cannot be reached',
    description:
      "The client's phone number does not support text messaging. (4700) Please resend text to a different phone number",
  },
  '4452': {
    title: 'Error Sending SMS',
    description: 'Text not delivered (4452) Please contact Otto Support',
  },
  '30005': {
    title: 'Client number cannot be reached',
    description:
      "The client's phone number does not support text messaging. (30005) Please resend text to a different phone number",
  },
  '4751': {
    title: 'Message too long',
    description: "The message exceeds the carrier's allowed length.",
  },
  '4470': {
    title: 'Message flagged as spam',
    description: 'Bandwidth blocked the message as spam.',
  },
  '4781': {
    title: 'Error Sending SMS',
    description: 'Text not delivered (4781) Please contact Otto Support.',
  },
  '4406': {
    title: 'Client number cannot be reached',
    description: `The client's phone number is not assigned to a carrier and cannot receive texts. (4406) Please resend text to a different phone number`,
  },
  '30006': {
    title: 'Client number cannot be reached',
    description: `The client's phone number does not support text messaging. (30006) Please resend text to a different phone number`,
  },
  '30003': {
    title: 'Client number cannot be reached',
    description:
      "The client's phone is turned off, out of coverage, or otherwise cannot receive SMS. (30003) Please resend as a Chat Message",
  },
  '4773': {
    title: 'Error Sending SMS',
    description: 'Text not delivered. (4773) Please contact Otto Support',
  },
  '4740': {
    title: 'Error Sending SMS',
    description: 'Text not delivered. (4740) Please contact Otto Support',
  },
  '4702': {
    title: 'Client number cannot be reached',
    description:
      'Client number cannot be reached at this time. (4702) Please resend text at a later time or resend text to a different phone number',
  },
  '5620': {
    title: 'Client carrier error',
    description: `The client's carrier could not deliver this text. (5620) Please resend as a Chat Message`,
  },
  '21610': {
    title: 'Client opted out of SMS',
    description: `The client has opted out of receiving text messages. (21610) Client must text 'Start' to clinic's number or contact their carrier to opt back in`,
  },
  '9999': {
    title: 'Error Sending SMS',
    description: 'Text not delivered. (9999) Please resend as Chat Message and contact Otto Support',
  },
  '5106': {
    title: 'Client number cannot be reached',
    description:
      'Client number cannot be reached at this time. (5106) Please resend text at a later time or resend text to a different phone number',
  },
  '30007': {
    title: `Message rejected by client's carrier`,
    description:
      'Twilio flagged the content of this message. (30007) Please resend as a Chat Message and contact Otto Support',
  },
  '4770': {
    title: 'Message blocked as spam',
    description: 'The carrier blocked the message as spam.',
  },
  '4771': {
    title: 'Shortened URL rejected',
    description: 'The message was rejected because of a shortened URL.',
  },
  '30034': {
    title: 'Error Sending SMS',
    description: 'Text not delivered. (30034) Please contact Otto Support',
  },
  '30024': {
    title: 'Error Sending SMS',
    description: 'Text not delivered. (30024) Please contact Otto Support',
  },
  '30008': {
    title: 'Client number cannot be reached',
    description:
      'Client number cannot be reached at this time. (30008) Please resend text at a later time or resend as a Chat Message',
  },
  '4730': {
    title: 'No route to carrier',
    description: 'The destination handset is roaming on a network that cannot be reached or routing was denied.',
  },
};
